<template>
    <header class="z-10">
        <div v-if="header" class="flex items-center gap-4 mb-1">
            <h2 data-dialog-focus="true" class="text-2xl font-medium" v-html="header"></h2>
            <span v-if="record && Object.keys(record).length > 0" class="font-medium text-secondary flex items-center">
                <span 
                    v-if="record.record_type !== 'Q' || (record.status.toLowerCase() === 'processing')" class="text-[.8rem] uppercase py-0.5 px-3 rounded-full inline-block"
                    :class="backgroundColorSourcing"
                >
                    {{ record.status }}
                </span>
            </span>
        </div>
        <div v-if="record" class="flex items-center gap-4 text-sm type-secondary">
            <span class="flex gap-2 after:content-['|'] after:ml-2 after:opacity-40 last:after:content-none" v-if="record.date">
                {{ record.record_type === 'O' ? '' : $t('Updated') }}
                <span class="type-primary">{{DateTime.fromISO(record.date).toFormat("D")}}</span>
            </span>
            <span class="flex gap-2 after:content-['|'] after:ml-2 after:opacity-40 last:after:content-none" v-if="record.entered_by && record.record_type === 'Q'">
                {{ $t("Entered") }}
                <span class="type-primary">{{ record.entered_by }}</span>
            </span>
            <span class="flex gap-2 after:content-['|'] after:ml-2 after:opacity-40 last:after:content-none" v-if="record.reference_id">
                {{ $t('Ref') }}
                <span class="type-primary">{{ record.reference_id }}</span>
            </span>
            <span class="flex gap-2 after:content-['|'] after:ml-2 after:opacity-40 last:after:content-none" v-if="record.purchase_order">
                {{ $t('PO') }}
                <span class="type-primary">{{ record.purchase_order }}</span>
            </span>
            <span class="flex gap-2 after:content-['|'] after:ml-2 after:opacity-40 last:after:content-none" v-if="record.job_rel">
                {{ $t('Job Ref #') }}
                <span class="type-primary">{{ record.job_rel }}</span>
            </span>
            <span class="flex gap-2 after:content-['|'] after:ml-2 after:opacity-40 last:after:content-none" v-if="record.ordered_by && record.record_type === 'O'">
                {{ $t("Ordered") }}
                <span class="type-primary">{{ record.ordered_by }}</span>
            </span>
            <span class="flex gap-2 after:content-['|'] after:ml-2 after:opacity-40 last:after:content-none" v-if="record.customer?.terms_code">
                {{ $t("Terms") }}
                <span class="type-primary">{{ record.customer?.terms_code }}</span>
            </span>
        </div>
    </header>
</template>

<script setup>
import { DateTime } from "luxon";
import { useStatus } from "@/Composables";
import { computed } from "vue";

const props = defineProps(["header", "record"]);

const { getStatusColors } = useStatus();

let backgroundColorSourcing = computed(() => getStatusColors(props.record?.status));

</script>
